import React, { useContext } from 'react';
import styled from 'styled-components';
import { Button } from '@ubeya/shared-web/components';
import ConfigContext from '../../contexts/ConfigContext';

const ViewButton = styled(Button)`
  background-color: transparent !important;
  &:hover {
    background-color: transparent !important;
  }
`;

export const DetailsCell = ({ onClick }) => {
  const { t } = useContext(ConfigContext);

  return (
    <ViewButton type="button" tertiary onClick={onClick}>
      {t('view')}
    </ViewButton>
  );
};
